import React from 'react';

interface BoxContentEndScrollbarsProps {
  message: string;
  show?: boolean;
}

const BoxContentEndScrollbars = ({message, show=true}: BoxContentEndScrollbarsProps) => {
  if (!show) return null;
  return (
    show &&
    <div className='text-xs flex items-center gap-4 my-2'>
      <hr className='w-full border-gray-100 border-dashed' />
      <span className='text-nowrap text-gray-200'>{ message }</span>
      <hr className='w-full border-gray-100 border-dashed' />
  </div>
  );
};

export default BoxContentEndScrollbars;
